import fullBody from '@assets/images/ai-model/back.png';
import top from '@assets/images/ai-model/top.png';
import bottom from '@assets/images/ai-model/bottom.png';

export const ZOOM_OPTIONS = [
	{ id: 1, name: 'Full body shot', value: 'full body shot', imagePath: fullBody },
	{ id: 2, name: 'Mid shot', value: 'midshot', imagePath: top },
	{ id: 3, name: 'Lower body shot', value: 'lower body shot', imagePath: bottom }
];

export const NATIONALITY_OPTIONS = [
	{ id: 1, name: 'European', value: 'European' },
	{ id: 2, name: 'American', value: 'American' },
	{ id: 3, name: 'African American', value: 'African American' },
	{ id: 4, name: 'Latino American', value: 'Latino American' },
	{ id: 5, name: 'Latino', value: 'Latino' },
	{ id: 6, name: 'West European', value: 'West European' },
	{ id: 7, name: 'East European', value: 'East European' },
	{ id: 8, name: 'Nordic', value: 'Nordic' },
	{ id: 9, name: 'Italian', value: 'Italian' },
	{ id: 10, name: 'German', value: 'German' },
	{ id: 11, name: 'French', value: 'French' },
	{ id: 12, name: 'British', value: 'British' },
	{ id: 13, name: 'African', value: 'African' },
	{ id: 14, name: 'Asian', value: 'Asian' },
	{ id: 15, name: 'East Asian', value: 'East Asian' },
	{ id: 16, name: 'Southeast Asian', value: 'Southeast Asian' },
	{ id: 17, name: 'South Asian', value: 'South Asian' }
];

export const GENDER_OPTIONS = [
	{ id: 1, name: 'Men', value: 'Men' },
	{ id: 2, name: 'Women', value: 'Women' },
	{ id: 3, name: 'Boys', value: 'Boys' },
	{ id: 4, name: 'Girls', value: 'Girls' },
	{ id: 5, name: 'Infant', value: 'Infant' },
	{ id: 6, name: 'Boys and Girls', value: 'Boys and Girls' },
	{ id: 7, name: 'Unisex', value: 'Unisex' },
	{ id: 8, name: 'Toddler', value: 'Toddler' }
];

export const BODY_TYPE_OPTIONS = [
	{ id: 1, name: 'Slim', value: 'Slim' },
	{ id: 2, name: 'Muscular', value: 'Muscular' },
	{ id: 3, name: 'Plus-Size', value: 'Plus-Size' },
	{ id: 4, name: 'Curvy', value: 'Curvy' },
	{ id: 5, name: 'Petite', value: 'Petite' }
];

export const HAIR_TYPE_OPTIONS = [
	{ id: 1, name: 'Straight', value: 'Straight' },
	{ id: 2, name: 'Curly', value: 'Curly' },
	{ id: 3, name: 'Wavy', value: 'Wavy' },
	{ id: 4, name: 'Coily', value: 'Coily' },
	{ id: 5, name: 'Bald', value: 'Bald' }
];

export const INITIAL_PROMPT_STATE = {
	nationality: { id: null, name: null, value: null },
	gender: { id: null, name: null, value: null },
	hairType: { id: null, name: null, value: null },
	bodyType: { id: null, name: null, value: null },
	zoomOption: { id: null, name: null, value: null }
};
